import { LoadableFactory } from '®shared/data';

import { ModalControlsLoadable } from './modal-controls-loadable';

export namespace ModalControlsLoadableFactory {
  export function show<T>(): ModalControlsLoadable<T> {
    return Object.assign(LoadableFactory.reset<T>(), {
      isShown: true,
    });
  }

  export function hide<T>(): ModalControlsLoadable<T> {
    return Object.assign(LoadableFactory.reset<T>(), {
      isShown: false,
    });
  }

  export function loading<T>(): ModalControlsLoadable<T> {
    return Object.assign(LoadableFactory.loading<T>(), {
      isShown: true,
    });
  }

  export function loaded<T>(data: T): ModalControlsLoadable<T> {
    return Object.assign(LoadableFactory.loaded<T>(data), {
      isShown: true,
    });
  }

  export function errorLoading<T>(error: any): ModalControlsLoadable<T> {
    return Object.assign(LoadableFactory.errored<T>(error), {
      isShown: true,
    });
  }
}
